import React, { useEffect, useContext } from "react"
import Page from "./Page"
import Axios from "axios"
import DispatchContext from "../DispatchContext"
import { CSSTransition } from "react-transition-group"
// import { AccordionActions } from "@material-ui/core"
import { useImmerReducer } from "use-immer"

function HomeGuest(props) {
  // const [username, setUsername] = useState()
  // const [email, setEmail] = useState()
  // const [password, setPassword] = useState()
  const appDispatch = useContext(DispatchContext)

  const initialState = {
    username: {
      value: "",
      hasErrors: false,
      message: ""
    },
    email: {
      value: "",
      hasErrors: false,
      message: "",
      isUnique: false,
      checkCount: 0
    },
    password: {
      value: "",
      hasErrors: false,
      message: ""
    },
    submitCount: 0
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "usernameImmediately":
        draft.username.hasErrors = false
        draft.username.value = action.value
        if (draft.username.value.length > 30) {
          draft.username.hasErrors = true
          draft.username.message = "Username cannot exceed 30 characters."
        }
        if (draft.username.value && !/^([a-zA-Z0-9]+)$/.test(draft.username.value)) {
          draft.username.hasErrors = true
          draft.username.message = "Username can only contain letters and numbers."
        }
        return
      case "usernameAfterDelay":
        if (draft.username.value.length < 3) {
          draft.username.hasErrors = true
          draft.username.message = "Username must be atleast three characters long. "
        }
        return
      case "emailImmediately":
        draft.email.hasErrors = false
        draft.email.value = action.value
        return
      case "emailAfterDelay":
        if (!/^\S+@\S+$/.test(draft.email.value)) {
          draft.email.hasErrors = true
          draft.email.message = "Please enter a valid email."
        }
        if (!draft.email.hasErrors && !action.noRequest) {
          draft.email.checkCount++
        }
        return
      case "emailUniqueResults":
        if (action.value) {
          draft.email.hasErrors = true
          draft.email.isUnique = false
          draft.email.message = "Ths email is already taken."
        } else {
          draft.email.isUnique = true
        }
        return
      case "passwordImmediately":
        draft.password.hasErrors = false
        draft.password.value = action.value
        if (draft.password.value.length > 50) {
          draft.password.hasErrors = true
          draft.password.message = "Password cannot exceed 50 characters."
        }
        return
      case "passwordAfterDelay":
        if (draft.password.value.length < 7) {
          draft.password.hasErrors = true
          draft.password.message = "Password must be atleast 7 characters"
        }
        return
      case "submitForm":
        if (!draft.username.hasErrors && !draft.email.hasErrors && !draft.password.hasErrors && draft.email.isUnique) {
          draft.submitCount++
        }
        return
      default:
    }
  }

  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  //when to render ourReducer cases

  useEffect(() => {
    if (state.username.value) {
      const delay = setTimeout(() => {
        dispatch({ type: "usernameAfterDelay" })
      }, 1000)
      return () => clearTimeout(delay)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.username.value])

  useEffect(() => {
    if (state.email.value) {
      const delay = setTimeout(() => {
        dispatch({ type: "emailAfterDelay" })
      }, 1000)
      return () => clearTimeout(delay)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.email.value])

  useEffect(() => {
    if (state.password.value) {
      const delay = setTimeout(() => {
        dispatch({ type: "passwordAfterDelay" })
      }, 1000)
      return () => clearTimeout(delay)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.password.value])

  useEffect(() => {
    if (state.email.checkCount) {
      const ourRequest = Axios.CancelToken.source()
      async function fetchResults() {
        try {
          const response = await Axios.post("/users/doesEmailExist", { email: state.email.value }, { cancelToken: ourRequest.token })
          dispatch({ type: "emailUniqueResults", value: response.data })
        } catch (e) {
          console.log("there was a problem")
        }
      }
      fetchResults()
      return () => ourRequest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.email.checkCount])

  useEffect(() => {
    if (state.submitCount) {
      const ourRequest = Axios.CancelToken.source()

      async function fetchResults() {
        try {
          const response = await Axios.post("/users", { name: state.username.value, email: state.email.value, password: state.password.value }, { cancelToken: ourRequest.token })
          appDispatch({ type: "flashMessage", value: "You have successfully sign up!" })
          appDispatch({ type: "login", data: response.data })
          // console.log(response)
        } catch (e) {
          appDispatch({ type: "flashMessage", value: "Enter correct details!!" })
          console.log("There was an error.")
        }
      }
      fetchResults()
      return () => ourRequest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.submitCount])

  function handleSubmit(e) {
    e.preventDefault()
    dispatch({ type: "usernameImmediately", value: state.username.value })
    dispatch({ type: "usernameAfterDelay", value: state.username.value })
    dispatch({ type: "emaiImmediately", value: state.email.value })
    dispatch({ type: "emailAfterDelay", value: state.email.value, noRequest: true })
    dispatch({ type: "passwordImmediately", value: state.email.value })
    dispatch({ type: "passwordAfterDelay", value: state.password.value })

    dispatch({ type: "submitForm" })
  }
  return (
    <Page title="Welcome!" wide={true}>
      <div id="wrap">
        <div id="main" className="container clear-top">
          <div className="row align-items-center">
            <div className="col-lg-7 py-3 py-md-5">
              <h1 className="display-4 mb-4">Your busy life deserves this.</h1>
              <p className="lead text-muted">
                The simplest way to keep notes!
                <br /> Wherever you are, take your note with you.
              </p>
            </div>
            <div className="col-lg-5 pl-lg-5 pb-3 py-lg-5">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="username-register" className="text-muted mb-1">
                    <small>Username</small>
                  </label>
                  <input onChange={e => dispatch({ type: "usernameImmediately", value: e.target.value })} id="username-register" name="username" className="form-control" type="text" placeholder="Pick a username" autoComplete="off" />
                  <CSSTransition in={state.username.hasErrors} timeout={330} classNames="liveValidateMessage" unmountOnExit>
                    <div className="alert alert-danger small liveValidateMessage">{state.username.message}</div>
                  </CSSTransition>
                </div>

                <div className="form-group">
                  <label htmlFor="email-register" className="text-muted mb-1">
                    <small>Email</small>
                  </label>
                  <input onChange={e => dispatch({ type: "emailImmediately", value: e.target.value })} id="email-register" name="email" className="form-control" type="text" placeholder="you@example.com" autoComplete="off" />
                  <CSSTransition in={state.email.hasErrors} timeout={330} classNames="liveValidateMessage" unmountOnExit>
                    <div className="alert alert-danger small liveValidateMessage">{state.email.message}</div>
                  </CSSTransition>
                </div>
                <div className="form-group">
                  <label htmlFor="password-register" className="text-muted mb-1">
                    <small>Password</small>
                  </label>
                  <input onChange={e => dispatch({ type: "passwordImmediately", value: e.target.value })} id="password-register" name="password" className="form-control" type="password" placeholder="Create a password" />
                  <CSSTransition in={state.password.hasErrors} timeout={330} classNames="livevalidateMessage" unmountOnExit>
                    <div className="alert alert-danger small liveValidateNessage">{state.password.message}</div>
                  </CSSTransition>
                </div>
                <button type="submit" className="py-3 mt-4 btn btn-lg btn-outline-dark btn-block">
                  Sign up for keeper
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default HomeGuest
